import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import { useCart } from "../context/CartContext";

const ProductCard = ({ product, index = 0 }) => {
  const { t, lang } = useLang();
  const { addItem, toggleWishlist, isWishlisted } = useCart();
  const name = lang === "fr" ? product.name_fr : product.name_en;
  const short = lang === "fr" ? product.short_fr : product.short_en;
  const liked = isWishlisted(product.id);

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group product-card"
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/product/${product.slug}`} className="block">
        <div className="img-wrap relative">
          <img src={product.image} alt={name} loading="lazy" />
          <button
            onClick={(e) => {
              e.preventDefault();
              toggleWishlist(product);
            }}
            className={`absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-white/90 backdrop-blur transition-all ${
              liked ? "text-[#B34A36]" : "text-[#1A1A1A] hover:text-[#B34A36]"
            }`}
            data-testid={`wishlist-toggle-${product.slug}`}
            aria-label="Toggle wishlist"
          >
            <Heart size={16} fill={liked ? "currentColor" : "none"} strokeWidth={1.5} />
          </button>

          <div className="absolute inset-x-3 bottom-3 opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
            <button
              onClick={(e) => {
                e.preventDefault();
                addItem(product);
              }}
              className="w-full bg-[#1E2B3C] text-white py-3 text-[11px] tracking-[0.2em] uppercase font-medium hover:bg-black transition-colors"
              data-testid={`add-to-cart-${product.slug}`}
            >
              {t.product.addToCart}
            </button>
          </div>
        </div>

        <div className="pt-4 flex items-start justify-between gap-4">
          <div className="min-w-0">
            <p className="text-[10px] tracking-[0.2em] uppercase text-[#B34A36] mb-1">
              {t.categories[product.category] || product.category}
            </p>
            <h3 className="font-serif-display text-lg md:text-xl text-[#1A1A1A] leading-tight truncate">
              {name}
            </h3>
            <p className="text-xs text-[#5C5C5C] mt-1 line-clamp-1">{short}</p>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
